export const LOGO_URL = "/logo192.png";

export const properties = [
  {
    id: "refuge-lyret",
    name: "Le Refuge du Lyret",
    type: { fr: "Appartement", en: "Apartment" },
    capacity: "2 à 6", capacityEn: "2 to 6",
    rating: 5.0, reviews: 15, favorite: true,
    amenities: ["balcony", "kitchen", "shower", "wifi", "raclette", "fondue", "ev_parking"],
    extra: { fr: "Balcon, cuisine, douche, parking avec recharge électrique", en: "Balcony, kitchen, shower, parking with EV charger" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/9e6fbvn2_Messenger_creation_4AB0D71D-AE0F-4805-B4C5-15F7E40183B2.jpeg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/cf2zgp8v_Messenger_creation_04BB47AE-B21F-42BD-9F5D-E90C6BFBBA5A.jpeg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/f8cx3ogr_Messenger_creation_D27157CD-378A-4DB5-9EDE-A84344DE2EE8.png",
    ],
    airbnb: "https://www.airbnb.fr/rooms/1305703023220337926?guests=1&adults=1&s=67&unique_share_id=cab86669-8c22-4802-b3cb-bade8a7a31e6",
  },
  {
    id: "chalet-les-lilas",
    name: "Chalet Les Lilas Vue Massif du Mont Blanc",
    type: { fr: "Demi-Chalet", en: "Half-Chalet" },
    capacity: "2 à 6",
    capacityEn: "2 to 6",
    rating: 4.67,
    reviews: 18,
    favorite: false,
    amenities: ["bath", "shower", "balcony", "library", "kitchen", "wifi", "raclette", "fondue", "parking"],
    extra: { fr: "1 salle de bain avec baignoire, salle de douche, balcon/Jardin, bibliothèque", en: "1 bathroom with bathtub, shower room, balcony/Garden, library" },
    photos: [
      "https://customer-assets.emergentagent.com/job_1bf02bff-bfc2-4d62-91a6-71a9588613d9/artifacts/h9777xc7_IMG-20250517-WA0009.jpg",
      "https://customer-assets.emergentagent.com/job_1bf02bff-bfc2-4d62-91a6-71a9588613d9/artifacts/dtj7rp3z_IMG-20250517-WA0025.jpg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/1427298439812937042?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
  {
    id: "vallee-gaillands",
    name: "Vallée des Gaillands à Chamonix",
    type: { fr: "Appartement 2 chambres", en: "2-bedroom Apartment" },
    capacity: "2 à 4", capacityEn: "2 to 4",
    rating: 4.86, reviews: 7, favorite: false,
    amenities: ["shower", "balcony", "kitchen", "wifi", "raclette", "fondue", "parking"],
    extra: { fr: "Parking couvert, 15 minutes du centre", en: "Covered parking, 15 minutes from center" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/2qhbqv7s_cd_00023.jpg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/lx2ymkvh_cd_00030.jpg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/1540667419001010116?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
  {
    id: "bouton-dor",
    name: "Le Bouton d'Or",
    type: { fr: "Appartement 2 chambres", en: "2-bedroom Apartment" },
    capacity: "2 à 4", capacityEn: "2 to 4",
    rating: 4.93, reviews: 30, favorite: true,
    amenities: ["shower", "kitchen", "wifi", "raclette", "fondue", "parking", "central"],
    extra: { fr: "Central", en: "Central" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/raw2wuwi_IMG-20241202-WA0013.jpg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/3yt1zf78_IMG-20241202-WA0025.jpg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/1302835815219575246?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
  {
    id: "chamonix-chic",
    name: "Le Chamonix Chic",
    type: { fr: "Appartement 2 chambres", en: "2-bedroom Apartment" },
    capacity: "2 à 4", capacityEn: "2 to 4",
    rating: 4.9, reviews: 10, favorite: true,
    amenities: ["shower", "kitchen", "wifi", "raclette", "fondue", "central"],
    extra: { fr: "Central", en: "Central" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/y9bymwz6_IMG-20240603-WA0002.jpg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/45cafii6_IMG-20240603-WA0009.jpg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/1171568025828516902?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
  {
    id: "charmant-chamois",
    name: "Le Charmant Chamois de Chamonix",
    type: { fr: "Studio", en: "Studio" },
    capacity: "2 à 4", capacityEn: "2 to 4",
    rating: 4.85, reviews: 97, favorite: false,
    amenities: ["bath", "balcony", "kitchen", "wifi", "raclette", "fondue", "parking", "central"],
    extra: { fr: "Salle de bain avec douche, coin cuisine, central", en: "Bathroom with shower, kitchenette, central" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/psalkuce_IMG-20231007-WA0003.jpg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/riaup5eh_IMG-20231007-WA0007.jpg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/999960346877482540?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
  {
    id: "magnifique-vue",
    name: "Magnifique Vue Mont-Blanc",
    type: { fr: "T2", en: "1-bedroom (T2)" },
    capacity: "2 à 4", capacityEn: "2 to 4",
    rating: 4.91, reviews: 56, favorite: false,
    amenities: ["bath", "shower", "balcony", "kitchen", "wifi", "raclette", "fondue", "parking", "central", "view"],
    extra: { fr: "Salle de bain avec baignoire, suite avec douche, 2x balcon, vue panoramique", en: "Bathtub bathroom, en-suite shower, 2 balconies, panoramic view" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/2zsn0rmj_IMG-20230911-WA0039.jpg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/hfsa4iqn_IMG-20251217-WA0017.jpg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/972489218670572315?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
  {
    id: "nid-douillet",
    name: "Nid Douillet Hyper Centre de Chamonix",
    type: { fr: "T2", en: "1-bedroom (T2)" },
    capacity: "2 à 4", capacityEn: "2 to 4",
    rating: 4.84, reviews: 57, favorite: true,
    amenities: ["bath", "balcony", "kitchen", "wifi", "raclette", "fondue", "parking", "central"],
    extra: { fr: "Salle de bain avec baignoire, coin cuisine, central", en: "Bathtub bathroom, kitchenette, central" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/sqeqlzjx_20231011_151344.jpg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/oo20j7bl_20231011_151409.jpg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/999956866154085889?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
  {
    id: "studio-lachenal",
    name: "Studio Lachenal, Chamonix",
    type: { fr: "Studio", en: "Studio" },
    capacity: "2 à 4", capacityEn: "2 to 4",
    rating: 4.79, reviews: 39, favorite: false,
    amenities: ["bath", "balcony", "kitchen", "wifi", "parking", "central"],
    extra: { fr: "Salle de bain avec baignoire, coin cuisine, central", en: "Bathtub bathroom, kitchenette, central" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/cnh0pd1f_Messenger_creation_3D063968-8D73-46D2-9857-1D6C8A5A3474.jpeg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/s26whyz1_Messenger_creation_39E874D3-615A-48AA-A3F2-5C6380FC80CF.jpeg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/1149231844901005119?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
  {
    id: "evasion-vallee",
    name: "Évasion dans la Vallée",
    type: { fr: "Studio", en: "Studio" },
    capacity: "2 à 4", capacityEn: "2 to 4",
    rating: 4.96, reviews: 27, favorite: true,
    amenities: ["bath", "balcony", "kitchen", "wifi", "parking", "central", "view"],
    extra: { fr: "Salle de bain avec baignoire balnéo, coin cuisine, vue panoramique", en: "Balneo bathtub, kitchenette, panoramic view" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/haobz12r_IMG-20251024-WA0000.jpg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/xseni0h5_IMG-20251024-WA0003.jpg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/1538903744235182178?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
  {
    id: "les-granges",
    name: "Les Granges",
    type: { fr: "Appartement 3 Chambres", en: "3-bedroom Apartment" },
    capacity: "2 à 6", capacityEn: "2 to 6",
    rating: 4.72, reviews: 18, favorite: false,
    amenities: ["bath", "balcony", "kitchen", "wifi", "raclette", "fondue", "parking"],
    extra: { fr: "1 salle de bain avec baignoire, balcon/Jardin, parking couvert", en: "1 bathtub bathroom, balcony/Garden, covered parking" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/9e46gmqp_received_856314996070309.jpeg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/dj48anii_received_982601949524973.jpeg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/972346559605822733?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
  {
    id: "aiguille-midi",
    name: "Au pied de l'Aiguille du Midi",
    type: { fr: "Studio", en: "Studio" },
    capacity: "2 à 4", capacityEn: "2 to 4",
    rating: 4.85, reviews: 52, favorite: true,
    amenities: ["bath", "balcony", "kitchen", "wifi", "raclette", "fondue", "parking", "central"],
    extra: { fr: "Salle de bain avec baignoire, coin cuisine, central", en: "Bathtub bathroom, kitchenette, central" },
    photos: [
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/lp4n9cqc_aQ2hhbW9pc05hdGg_20231019170157_98889_2e96fcd.jpg",
      "https://customer-assets.emergentagent.com/job_chamonix-locations/artifacts/8ban6bhn_aQ2hhbW9pc05hdGg_20231019170320_04268_f1f051e.jpg",
    ],
    airbnb: "https://www.airbnb.fr/rooms/1007069156205857550?guests=1&adults=1&s=67&unique_share_id=chamonix-locations",
  },
];
